import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
`;

export const PageTitle = styled.h1`
  font-size: 2.5rem;
  text-align: center;
  margin: 1.5rem 0;
  color: var(--primary-color);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
`;

export const GameGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 2rem;
  margin: 2rem 0;
`;

export const GameCard = styled.div<{ bgColor: string }>`
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  overflow: hidden;
  transition: transform 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-8px);
  }

  .game-icon {
    height: 160px;
    background-color: ${props => props.bgColor || 'var(--primary-color)'};
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .game-info {
    padding: 1.5rem;

    h3 {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
    }

    p {
      font-size: 1rem;
      color: #666;
    }

    .game-category {
      display: inline-block;
      background-color: ${props => props.bgColor || 'var(--primary-color)'};
      color: white;
      padding: 0.25rem 0.5rem;
      border-radius: 4px;
      margin-top: 0.5rem;
      font-size: 0.85rem;
    }
  }
`;

export const GameContainer = styled.div`
  background-color: white;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  padding: 2rem;
  margin: 2rem 0;
`;

export const Button = styled.button<{ variant?: 'primary' | 'secondary' | 'success' | 'error' }>`
  background-color: ${props => {
    switch (props.variant) {
      case 'secondary':
        return 'var(--secondary-color)';
      case 'success':
        return 'var(--success-color)';
      case 'error':
        return 'var(--error-color)';
      default:
        return 'var(--primary-color)';
    }
  }};
  font-size: 1.2rem;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius);
  color: white;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: var(--box-shadow);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const FlexContainer = styled.div<{ direction?: 'row' | 'column', justify?: string, align?: string }>`
  display: flex;
  flex-direction: ${props => props.direction || 'row'};
  justify-content: ${props => props.justify || 'center'};
  align-items: ${props => props.align || 'center'};
  width: 100%;
`;

export const ChoiceButton = styled.button<{ isCorrect?: boolean | null, isSelected?: boolean }>`
  padding: 1rem 2rem;
  margin: 0.5rem;
  font-size: 1.5rem;
  font-family: var(--font-family) !important;
  border-radius: var(--border-radius);
  background-color: ${props => {
    if (props.isSelected) {
      return props.isCorrect ? 'var(--success-color)' : 'var(--error-color)';
    }
    return 'white';
  }};
  color: ${props => (props.isSelected ? 'white' : 'var(--text-color)')};
  border: 3px solid var(--secondary-color);
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 100px;
  box-shadow: ${props => (props.isSelected ? 'none' : '0 4px 0 var(--secondary-color)')};
  transform: ${props => (props.isSelected ? 'translateY(4px)' : 'none')};

  &:hover {
    background-color: ${props => {
    if (props.isSelected) {
      return props.isCorrect ? 'var(--success-color)' : 'var(--error-color)';
    }
    return 'var(--secondary-color)';
  }};
    color: white;
  }

  @media (max-width: 768px) {
    padding: 0.75rem 1.5rem;
    font-size: 1.25rem;
    min-width: 80px;
    margin: 0.3rem;
  }
`;

export const DraggableItem = styled.div<{ isDragging?: boolean }>`
  padding: 1rem;
  margin: 0.5rem;
  background-color: ${props => (props.isDragging ? 'var(--secondary-color)' : 'white')};
  border: 3px solid var(--secondary-color);
  border-radius: var(--border-radius);
  cursor: grab;
  user-select: none;
  transition: all 0.2s ease;
  box-shadow: ${props => (props.isDragging ? 'var(--box-shadow)' : '0 4px 0 var(--secondary-color)')};
  font-size: 1.5rem;
  color: ${props => (props.isDragging ? 'white' : 'var(--text-color)')};

  &:active {
    cursor: grabbing;
  }
`;

export const DropZone = styled.div<{ isOver?: boolean, canDrop?: boolean }>`
  padding: 1rem;
  margin: 0.5rem;
  background-color: ${props => {
    if (props.isOver && props.canDrop) return 'rgba(76, 175, 80, 0.3)';
    if (props.isOver) return 'rgba(244, 67, 54, 0.3)';
    return 'rgba(0, 0, 0, 0.1)';
  }};
  border: 3px dashed ${props => {
    if (props.isOver && props.canDrop) return 'var(--success-color)';
    if (props.isOver) return 'var(--error-color)';
    return 'rgba(0, 0, 0, 0.3)';
  }};
  border-radius: var(--border-radius);
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
